export const cleanMD = (text: string): string => {
  const result = text.replaceAll("\n\n-", "\n-");
  return result;
};
